export default "__VITE_ASSET__QugNyhf4__"